import { render, staticRenderFns } from "./PopupRegistrationSuccessful.vue?vue&type=template&id=75dfb8bd"
import script from "./PopupRegistrationSuccessful.vue?vue&type=script&lang=js"
export * from "./PopupRegistrationSuccessful.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports